import React, { useMemo } from 'react';

type AccreditingBodiesProviderProps = {
  children: React.ReactNode;
};

export type AccreditingBodiesProviderResponse = {};

export const AccreditingBodiesContext = React.createContext<AccreditingBodiesProviderResponse>(
  {} as AccreditingBodiesProviderResponse
);

const AccreditingBodiesProvider: ({ children }: AccreditingBodiesProviderProps) => any = ({ children }) => {
  const contextValue: AccreditingBodiesProviderResponse = useMemo(() => ({}), []);

  return <AccreditingBodiesContext.Provider value={contextValue}>{children}</AccreditingBodiesContext.Provider>;
};

export default AccreditingBodiesProvider;
